import React, { useState,useEffect } from "react";
import axios from "axios";
import { Link,useNavigate, useLocation } from "react-router-dom";
import API_URLS from "../config/apiConfig";
import swal from 'sweetalert';
import { ClipLoader } from "react-spinners";

const CourseCategoryForm = () => {
   const authToken = localStorage.getItem("token");
   const navigate = useNavigate();
   const location = useLocation();
   const [loading, setLoading] = useState(false);
   const [formData, setFormData] = useState({
      id: null,
      category: "",     
    });
   const categoryToEdit = location.state?.category;
   const [errors, setErrors] = useState({});  
   useEffect(() => {
    if (categoryToEdit) {
      console.log(categoryToEdit);
      setFormData({
        id: categoryToEdit.id, // Include the id
        category: categoryToEdit.category,
      });    
    }
  }, [categoryToEdit]);

   // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" }); // Clear errors on input change
  };
   // Validate form inputs
   const validate = () => {
    const newErrors = {};
   
   if (!formData.category.trim()){ newErrors.category = "Please enter category name";}
   return newErrors;
  };
    // Handle form submission
   const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setLoading(true);
    try {
      console.log(formData);
      //return false;
      const response = await axios.post(API_URLS.COURSES_CATEGORY_SAVE, formData,{
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      if(response.data.success==1){
      swal("Success", response.data.message, "success").then(() => {
        navigate("/manager/course-categories"); // Redirect to the target page
      });
     
      }else{
      swal("Error", response.data.message, "error");  
      }
      
      console.log(response.data); // Handle response
    } catch (error) {
      swal("Error", "Please try again.", "error");  
      console.error("Error:", error.response?.data || error.message);
    }finally {
      setLoading(false); 
    }
  };
    return (
    <>
    
     {loading && (
                    <div className="loader-overlay">
                        <ClipLoader color="#08A9E6" loading={loading} size={50} />
                    </div>
                )}
    <div className="contact-form">
                                    <h3 className="user-title"> {categoryToEdit ? 'Edit Category' : 'Add Category'} </h3>
                                    <form id="signupForm" name="signupForm" method="post" onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <input type="text" className="form-control" name="category"  placeholder="Category Name" value={formData.category}  onChange={handleChange} />
                                  {errors.category && <p style={{ color: "red" }}>{errors.category}</p>}
                                                </div>
                                            </div>
                                           
    
                                            <div className="col-lg-12 col-md-12 mt-2">
                                                <button type="submit" className="default-btn" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                                </button>
                                                
                                            </div>
                                        </div>
                                    </form>
                                </div>
    
    </>
    );
}
export default CourseCategoryForm;